import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#debt-calculator-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'UAH';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#debt-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const culture = $container.data('culture') || 'uk-UA';
    const localeMap = { 'uk': 'uk-UA', 'pl': 'pl-PL', 'de': 'de-DE', 'es': 'es-ES', 'it': 'it-IT', 'en': 'en-US' };
    const dateLocale = localeMap[culture] || 'en-US';

    const unitPerMonth = $container.data('unit-per-month') || '/ міс';
    const unitMonths = $container.data('unit-months') || 'міс.';
    const chartSnowballName = $container.data('chart-snowball') || 'Снігова куля (Snowball)';
    const chartAvalancheName = $container.data('chart-avalanche') || 'Лавина (Avalanche)';
    const newDebtName = $container.data('new-debt-name') || 'Новий кредит';
    const colBalance = $container.data('col-balance') || 'Залишок';
    const colRate = $container.data('col-rate') || 'Ставка %';
    const colMin = $container.data('col-min') || 'Мін. платіж';
    const deleteTooltip = $container.data('delete-tooltip') || 'Видалити';

    const $extraRange = $('#debt-extra-range');
    const $extraDisplay = $('#debt-extra-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString(dateLocale) + ' ' + symbol;
    }

    function getDebts() {
        const debts = [];
        $('.debt-row').each(function () {
            const name = $(this).find('.debt-name').val() || newDebtName;
            const balance = parseFloat($(this).find('.debt-balance').val()) || 0;
            const rate = (parseFloat($(this).find('.debt-rate').val()) || 0) / 100;
            const minPayment = parseFloat($(this).find('.debt-min').val()) || 0;

            if (balance > 0) {
                debts.push({ name, balance, rate, minPayment });
            }
        });
        return debts;
    }

    function simulateStrategy(debtsInput, extraPayment, strategyType) {
        // Deep copy
        const debts = debtsInput.map(d => ({ ...d }));
        let totalInterestPaid = 0;
        let months = 0;
        const maxMonths = 360; // 30 years cap
        const balanceHistory = [];

        while (debts.some(d => d.balance > 0.01) && months < maxMonths) {
            months++;
            let currentTotalBalance = 0;
            let availableExtra = extraPayment;

            // 1. Accrue monthly interest & collect freed minimums
            debts.forEach(d => {
                if (d.balance > 0) {
                    const monthlyInterest = d.balance * (d.rate / 12);
                    d.balance += monthlyInterest;
                    totalInterestPaid += monthlyInterest;
                }
            });

            // 2. Pay minimums first
            debts.forEach(d => {
                if (d.balance > 0) {
                    const payment = Math.min(d.balance, d.minPayment);
                    d.balance -= payment;
                    if (d.balance <= 0.01) {
                        d.balance = 0;
                    }
                }
            });

            // 3. Sort active debts according to strategy
            const activeDebts = debts.filter(d => d.balance > 0);
            if (strategyType === 'snowball') {
                activeDebts.sort((a, b) => a.balance - b.balance); // smallest balance first
            } else {
                activeDebts.sort((a, b) => b.rate - a.rate); // highest interest rate first
            }

            // 4. Apply extra payment to top target debt
            for (let i = 0; i < activeDebts.length; i++) {
                if (availableExtra <= 0) break;
                const d = activeDebts[i];
                const payment = Math.min(d.balance, availableExtra);
                d.balance -= payment;
                availableExtra -= payment;
                if (d.balance <= 0.01) {
                    d.balance = 0;
                }
            }

            debts.forEach(d => {
                currentTotalBalance += d.balance;
            });

            balanceHistory.push(Math.round(currentTotalBalance));
        }

        return {
            months,
            totalInterest: Math.round(totalInterestPaid),
            balanceHistory
        };
    }

    function calculate() {
        const extraPayment = parseFloat($extraRange.val()) || 0;
        $extraDisplay.text('+' + formatMoney(extraPayment) + ' ' + unitPerMonth);

        const debts = getDebts();
        if (debts.length === 0) {
            $('#debt-kpi-saved').text('0 ' + symbol);
            $('#debt-kpi-months-saved').text('0 ' + unitMonths);
            $('#debt-kpi-date').text('—');
            return;
        }

        const snowball = simulateStrategy(debts, extraPayment, 'snowball');
        const avalanche = simulateStrategy(debts, extraPayment, 'avalanche');

        const interestSaved = Math.max(0, snowball.totalInterest - avalanche.totalInterest);
        const monthsSaved = Math.max(0, snowball.months - avalanche.months);

        // Freedom date
        const now = new Date();
        now.setMonth(now.getMonth() + avalanche.months);
        const freeDateStr = now.toLocaleDateString(dateLocale, { month: 'short', year: 'numeric' });

        $('#debt-kpi-saved').text(formatMoney(interestSaved));
        $('#debt-kpi-months-saved').text(monthsSaved + ' ' + unitMonths);
        $('#debt-kpi-date').text(freeDateStr);

        $('#debt-snowball-interest').text(formatMoney(snowball.totalInterest));
        $('#debt-snowball-months').text(snowball.months + ' ' + unitMonths);

        $('#debt-avalanche-interest').text(formatMoney(avalanche.totalInterest));
        $('#debt-avalanche-months').text(avalanche.months + ' ' + unitMonths);

        renderChart(snowball.balanceHistory, avalanche.balanceHistory);
    }

    function renderChart(snowballHistory, avalancheHistory) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';
        const maxLen = Math.max(snowballHistory.length, avalancheHistory.length);

        const labels = [];
        const sData = [];
        const aData = [];

        for (let i = 0; i < maxLen; i += Math.max(1, Math.floor(maxLen / 12))) {
            labels.push(i + ' ' + unitMonths);
            sData.push(snowballHistory[i] !== undefined ? snowballHistory[i] : 0);
            aData.push(avalancheHistory[i] !== undefined ? avalancheHistory[i] : 0);
        }

        const options = {
            series: [
                { name: chartSnowballName, data: sData },
                { name: chartAvalancheName, data: aData }
            ],
            chart: {
                type: 'line',
                height: 250,
                toolbar: { show: false },
                animations: { enabled: true, speed: 400 }
            },
            colors: ['#50a5f1', '#34c38f'],
            stroke: { curve: 'smooth', width: 3 },
            dataLabels: { enabled: false },
            xaxis: {
                categories: labels,
                labels: { style: { colors: isDark ? '#a6b0cf' : '#74788d' } }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        if (val >= 1000) return Math.round(val / 1000) + 'K ' + symbol;
                        return Math.round(val) + ' ' + symbol;
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            tooltip: {
                theme: isDark ? 'dark' : 'light',
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        const chartEl = document.querySelector('#debt-payoff-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Input listeners
    $extraRange.on('input', calculate);
    $(document).on('input', '.debt-balance, .debt-rate, .debt-min', calculate);

    // Add Debt Row
    $('#btn-add-debt').on('click', function () {
        const count = $('.debt-row').length;
        const newRow = `
            <div class="debt-row p-2 border rounded bg-light" data-index="${count}">
                <div class="d-flex justify-content-between align-items-center mb-1">
                    <input type="text" class="form-control form-control-sm fw-semibold debt-name me-2" value="${newDebtName} ${count + 1}">
                    <button type="button" class="btn btn-sm btn-link text-danger p-0 btn-remove-debt" title="${deleteTooltip}">
                        <i class="bx bx-trash font-size-16"></i>
                    </button>
                </div>
                <div class="row g-2">
                    <div class="col-4">
                        <label class="font-size-11 text-muted mb-0">${colBalance}</label>
                        <input type="number" class="form-control form-control-sm debt-balance" value="20000" step="500">
                    </div>
                    <div class="col-4">
                        <label class="font-size-11 text-muted mb-0">${colRate}</label>
                        <input type="number" class="form-control form-control-sm debt-rate" value="25.0" step="0.5">
                    </div>
                    <div class="col-4">
                        <label class="font-size-11 text-muted mb-0">${colMin}</label>
                        <input type="number" class="form-control form-control-sm debt-min" value="1000" step="100">
                    </div>
                </div>
            </div>`;
        $('#debts-list-container').append(newRow);
        calculate();
    });

    // Remove Debt Row
    $(document).on('click', '.btn-remove-debt', function () {
        $(this).closest('.debt-row').remove();
        calculate();
    });

    // Currency Switcher
    function setDebtCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#debt-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.debt-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.debt-more-currencies-btn').addClass('active');
            $('#debt-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#debt-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.debt-more-currencies-btn').removeClass('active');
            $('.debt-currency-dropdown-item').removeClass('active');
            $('#debt-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const defExtra = parseFloat($(btn).data('default-extra')) || 3000;
        $extraRange.val(defExtra);

        if (currency === 'USD' || currency === 'EUR' || currency === 'GBP' || currency === 'CHF' || currency === 'CAD') {
            $extraRange.attr({ max: 2000, step: 25 });
        } else if (currency === 'PLN') {
            $extraRange.attr({ max: 8000, step: 100 });
        } else {
            $extraRange.attr({ max: 30000, step: 250 });
        }

        calculate();
    }

    $('#debt-currency-tabs > button[data-currency-code]').on('click', function () {
        setDebtCurrency(this, false);
    });

    $(document).on('click', '.debt-currency-dropdown-item', function (e) {
        e.preventDefault();
        setDebtCurrency(this, true);
    });

    calculate();
});

